export interface CompanySupportDto {
  email: string;
  topic: string;
  feedback: string;
}
